import React, { useState } from 'react';

import { AnimatePresence } from 'framer-motion';

import MinusIcon from './icons/minus.svg?react';
import PlusIcon from './icons/plus.svg?react';

import { Content, ContentScroll, Count, Label, Toggle, ToggleIcon, Wrapper } from './styles';

interface Props {
    label: string;
    count?: number;
    children?: React.ReactNode;
    fillHeight?: boolean;
}

export const FilterGroup = ({ label, count, children, fillHeight }: Props) => {
    const [expanded, setExpanded] = useState(true);

    return (
        <Wrapper $fillHeight={fillHeight}>
            <Toggle onClick={() => setExpanded(!expanded)} $expanded={expanded}>
                <Label>
                    {label} {Boolean(count) && <Count>{count}</Count>}
                </Label>
                <ToggleIcon>{expanded ? <MinusIcon /> : <PlusIcon />}</ToggleIcon>
            </Toggle>
            <AnimatePresence initial={false}>
                {expanded && (
                    <Content
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: 'auto' }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{
                            duration: 0.2,
                            ease: 'easeInOut',
                        }}
                    >
                        <ContentScroll>{children}</ContentScroll>
                    </Content>
                )}
            </AnimatePresence>
        </Wrapper>
    );
};
